import { DataTable, DataTableMessageRow } from 'components/DataTable'
import { Pill } from 'components/ManagementCard'
import { adCodeStrings, commonStrings } from 'constants/strings'
import type { TAdCodeAttribution } from 'types'
import {
  confidenceLabel,
  formatDateTime,
  friendStateLabel,
} from '../adCodeDisplay'

type Props = {
  attributions: TAdCodeAttribution[]
  loading: boolean
}

const COLUMN_COUNT = 6

export function AttributionsTable({ attributions, loading }: Props) {
  let body: JSX.Element | JSX.Element[]

  if (loading) {
    body = (
      <DataTableMessageRow
        colSpan={COLUMN_COUNT}
        message={commonStrings.loading}
      />
    )
  } else if (attributions.length === 0) {
    body = (
      <DataTableMessageRow
        colSpan={COLUMN_COUNT}
        message={adCodeStrings.detail.attributionsEmpty}
      />
    )
  } else {
    body = attributions.map((row) => (
      <tr
        key={`${row.userLineId}-${row.attributedAt}`}
        className="border-t border-border/60 bg-white"
      >
        <td className="px-2 py-3 text-sm text-ink">{row.name}</td>
        <td className="px-2 py-3 text-[11px] text-ink sm:text-sm">
          {row.lineChannel ? `@${row.lineChannel.basicId}` : '—'}
        </td>
        <td className="px-2 py-3 font-mono text-[11px] text-ink">
          {formatDateTime(row.attributedAt)}
        </td>
        <td className="px-2 py-3 text-[11px]">
          {/* 確定と推定は色でなく文字でも区別する */}
          <Pill tone={row.confidence === 'HIGH' ? 'success' : 'warning'}>
            {confidenceLabel(row.confidence)}
          </Pill>
          <span className="ml-1 text-[10px] text-muted">
            {adCodeStrings.method[row.method]}
          </span>
        </td>
        <td className="px-2 py-3 text-[11px] text-ink sm:text-sm">
          {row.isNewFriend
            ? adCodeStrings.kind.new
            : adCodeStrings.kind.refollow}
        </td>
        <td className="px-2 py-3 text-[11px]">
          {row.isBlocked ? (
            <Pill tone="danger">{friendStateLabel(row)}</Pill>
          ) : (
            <span className="text-ink">{friendStateLabel(row)}</span>
          )}
        </td>
      </tr>
    ))
  }

  return (
    <DataTable
      minWidthClassName="min-w-[720px]"
      tableLayout="auto"
      headerRow={
        <tr>
          <th className="px-2 py-3 text-left">
            {adCodeStrings.columns.lineName}
          </th>
          <th className="px-2 py-3 text-left">
            {adCodeStrings.columns.receivedAccount}
          </th>
          <th className="px-2 py-3 text-left">
            {adCodeStrings.columns.attributedAt}
          </th>
          <th className="px-2 py-3 text-left">
            {adCodeStrings.columns.confidence}
          </th>
          <th className="px-2 py-3 text-left">{adCodeStrings.columns.kind}</th>
          <th className="px-2 py-3 text-left">{adCodeStrings.columns.state}</th>
        </tr>
      }
    >
      {body}
    </DataTable>
  )
}
